window.addEventListener('load', function () {
  const mainElement = document.querySelector('body')
  if (mainElement && mainElement.classList.contains('lp_region')) {
    document.querySelectorAll('.anim-details').forEach((detail) => {
      const summary = detail.querySelector('summary')
      summary.addEventListener('click', (e) => {
        e.preventDefault()

        // すでに開いてたら閉じる
        if (detail.hasAttribute('open')) {
          detail.classList.remove('open')
          setTimeout(() => {
            detail.removeAttribute('open')
          }, 400) // CSSのtransition時間に合わせる
        } else {
          detail.setAttribute('open', '')
          requestAnimationFrame(() => {
            detail.classList.add('open')
          })
        }
      })
    })
  }
})
